import React, { useState, useEffect } from 'react';
import { load } from 'recaptcha-v3' //Recaptcha loader
import CryptoJS from "crypto-js";

import { 
	AlertMessage, 
	FormInput_text, FormInput_confirm,
	Button, Spinner,

	CustomPasswordInput, CustomUsernameInput, CustomEmailInput,

	ConfirmationModal
} from "components";

import { useLogin } from "hooks";

import { func_validation, func_url, func_cookie } from 'functions';

import formLogo from 'assets/images/xilnex_official_logo_grey.svg';

import { distributorPortalBaseUrl } from "dataflow/distributorPortal/constants";

import 'assets/scss/distributorPortal/modules/login.scss';



export default function LoginPresentation(props) {
	// Props
	const { 
		login_requesting, getUserInfo_requesting, userInfo,
		
		generateEmailOTP_requesting, generateEmailOTP_status,
		generateEmailOTP_errorMsg,
	} = props;

	// States
	const [recaptchaObj, setRecaptchaObj] = useState(null);
	const [forgotPassword_email, setForgotPassword_email] = useState();
	const [forgotPassword_isEmailValid, setForgotPassword_isEmailValid] = useState();
	const [forgotPassword_isOTPSubmissionAttempted, setForgotPassword_isOTPSubmissionAttempted] = useState();
	const [forgotPassword_alertMsg, setForgotPassword_alertMsg] = useState();
	const [forgotPassword_isAlertMsgVisible, setForgotPassword_isAlertMsgVisible] = useState();
	const [isModalVisible_forgotPassword, setIsModalVisible_forgotPassword] = useState();

	//Recaptcha
	useEffect(() => {
		const loadRecaptcha = async () => {
			try {
				const recaptchaObj = await load('6Ld9j4EpAAAAAFKRQKqjTaL5O6gsiSr67_hKMpQ-');
				setRecaptchaObj(recaptchaObj);
			} catch (error) {
				console.error('Error loading Recaptcha:', error);
			}
		};

		loadRecaptcha();
	}, []);

	// Forgot Password Alert Message
	useEffect(() => {
		if (func_validation.isBooleanTrueNotNullUndefined(generateEmailOTP_status)) {
			setForgotPassword_alertMsg("Please check for email in your inbox as well as the Spam or Junk folder.");
			setForgotPassword_isAlertMsgVisible(true);
		}
		else if (func_validation.isBooleanFalseNotNullUndefined(generateEmailOTP_status) &&
			func_validation.isStringTrimNotEmpty(generateEmailOTP_errorMsg)) {
			setForgotPassword_alertMsg(generateEmailOTP_errorMsg);
			setForgotPassword_isAlertMsgVisible(true);
		}
	}, [generateEmailOTP_status]);

	// Hooks
	const {
		email, setEmail,
        isEmailValid, setEmailValidity,
        username, setUsername,
        password, setPassword,
        rememberMe, setRememberMe,
        isFormSubmissionAttempted,

		handleSubmit,
		
		isAlertMsgVisible, alertMsg, setIsAlertMsgVisible
	} = useLogin({
		...props,
		recaptchaObj: recaptchaObj,
		refreshTokenCookieName: "refresh_token_dp",
		handleOnSuccess: () => {
			let role = func_validation.getObjectPropertyValue(userInfo, "Role");

			if (func_validation.isStringEqual_caseInsensitive(role, "Dealer")) {
				let cryptoObj = CryptoJS.SHA3("Message");
				let cookieValue = cryptoObj.toString(CryptoJS.enc.Base64);
	
				func_cookie.setCookie("in", cookieValue, { path: '/' });
				func_url.historyPushToURL(props, distributorPortalBaseUrl + "dashboard");
			}
		},
		authorized_urlRedirection:  distributorPortalBaseUrl + "dashboard",
		urlRedirectValidation: () => {
			let role = func_validation.getObjectPropertyValue(userInfo, "Role");
			return func_validation.isStringEqual_caseInsensitive(role, "Dealer");
		}
	});

	// Forgot Password
	function handleOnConfirm_forgotPassword() {
		if (func_validation.isStringTrimNotEmpty(forgotPassword_email) &&
			props.generateEmailOTP)
			props.generateEmailOTP(forgotPassword_email);
	}

	return (
		<div className={"distributorPortal-login d-inline-flex"}>
			{/* Forgot Password Modal */}
			<ConfirmationModal
				className={"distributorPortal-login-forgotPassword"}
				description={"Forgot Your Password?"}

				headerClassName={"distributorPortal-login-forgotPassword-header"}

				bodyHeader={(
					<AlertMessage
						wrapperclassName={"distributorPortal-login-forgotPassword-alertMsg"}
						headerMsg={generateEmailOTP_status? "OTP is sent to Your Email":""}
						message={forgotPassword_alertMsg}
						alertType={generateEmailOTP_status? "success":"error"}
						isVisible={forgotPassword_isAlertMsgVisible}
						toggleVisibility={() => { setForgotPassword_isAlertMsgVisible(!forgotPassword_isAlertMsgVisible); }}
					/>
				)}

				input={(
					<CustomEmailInput
						customInputClassName={"distributorPortal-login-forgotPassword-input"}

						email={forgotPassword_email}
						handleValueChange={setForgotPassword_email}
						isEmailValid={forgotPassword_isEmailValid}
						handleEmailValidity={setForgotPassword_isEmailValid}

						isFormSubmissionAttempted={forgotPassword_isOTPSubmissionAttempted}

						handleOnEnterPressed={handleOnConfirm_forgotPassword}

						options={{
							isLabelOptional: false,
							isInputOptional: false,
							inputLabel: "Enter your email address"
						}}
					/>
				)}

				cancelButtonText={"Cancel"}
				confirmButtonText={"Confirm"}
				isModalVisible={isModalVisible_forgotPassword}
				updateParentState={setIsModalVisible_forgotPassword}
				handleOnConfirm={handleOnConfirm_forgotPassword}
				isActionLoading={generateEmailOTP_requesting}
			/>

			<div className={"distributorPortal-login-formWrapper d-flex justify-content-center align-items-center"}>
				{/* Form */}
				<div className={"distributorPortal-login-form d-flex flex-column align-items-center"}>
					<div className={"distributorPortal-login-formLogo"}>
						<img
							src={formLogo}
							alt={"Xilnex Logo"}
						/>
					</div>

					<div className="distributorPortal-login-title text-center">Business Partner Portal</div>

					{/* Alert Message */}
					<div className={"distributorPortal-login-alertMsgWrapper"}>
						<AlertMessage
							message={alertMsg}
							isVisible={isAlertMsgVisible}
							toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}

							isAlertTypeIconHidden isCloseIconHidden
						/>
					</div>

					<div className={"distributorPortal-login-inputWrapper"}>
						{/* Username */}
						{/* <CustomUsernameInput
							className={"distributorPortal-login-usernameInput"}

							username={username}
							isFormSubmissionAttempted={isFormSubmissionAttempted}

							handleValueChange={setUsername}
							handleOnEnterPressed={handleSubmit}
						/> */}

						{/* Email */}
						<CustomEmailInput
							customInputClassName={"distributorPortal-login-emailInput"}

							email={email}
							handleValueChange={setEmail}
							isEmailValid={isEmailValid}
							handleEmailValidity={setEmailValidity}

							isFormSubmissionAttempted={isFormSubmissionAttempted}

							handleOnEnterPressed={handleSubmit}
						/>

						{/* Password */}
						<CustomPasswordInput
							customInputClassName={"distributorPortal-login-passwordInput"}

							password={password}
							isFormSubmissionAttempted={isFormSubmissionAttempted}

							handleValueChange={setPassword}
							handleOnEnterPressed={handleSubmit}
							
							options={{
								isForgotPasswordRequired: true,
								forgotPasswordClassName: "distributorPortal-login-passwordInput-forgotPassword",
								handleOnClick_forgotPassword: () => { setIsModalVisible_forgotPassword(true); },
								isSideIconDark: true,
							}}
						/>

						{/* Remember Me */}
						{/* <FormInput_confirm 
							customInputClassName={"distributorPortal-login-rememberMeWrapper"} 
							inputDescriptionClassName={"distributorPortal-login-rememberMeLabel"} 

							isLabelOptional inputName={'rememberMe'} 
							inputStateName={'rememberMe'} inputValue={rememberMe} 
							inputDescription={"Remember Me"}
							propagateValueChange={(stateName, value) => { setRememberMe(value); }}
							isFormSubmissionAttempted={isFormSubmissionAttempted} 
							isErrorOptional 
						/> */}
					</div>

					{/* Login Button */}
					<Button 
						className={"distributorPortal-login-submitButton"}
						handleOnClick={handleSubmit}

						isDecoration_secondary
					>
						Login {(login_requesting || getUserInfo_requesting) && <Spinner size={0} />}
					</Button>

					{/* Recaptcha */}
					{/* <Recaptcha
						ref={ ref => recaptcha = ref }
						sitekey={"6Lcf9LEUAAAAANqv7HUxH_yt6zVNKqUt6J2wu1XD"}
						onResolved={ onResolved }
					/> */}
					
				</div>
			</div>
		</div>
	);
}